import React from "react";
import Container from "react-bootstrap/Container";
import Photo from "./kordik_2.png";

const skillGroups = [
  {
    title: "Core Stack",
    level: "core",
    skills: ["React", "TypeScript", "JavaScript", "React Native", "Expo", "Node.js", "Express", "Next.js", "Firebase", "Cloud Firestore"],
  },
  { title: "Frontend", skills: ["HTML", "CSS", "Tailwind CSS"] },
  { title: "Mobile & APIs", skills: ["Flutter", "REST APIs"] },
  { title: "Data", skills: ["MongoDB", "SQL"] },
  { title: "Firebase", skills: ["Auth", "Cloud Functions v2", "App Check", "Analytics", "Crashlytics"] },
  { title: "Analytics", skills: ["Google Analytics 4 (GA4)", "Firebase Analytics"] },
  { title: "Testing / Delivery", skills: ["Vitest", "Playwright", "Firebase Emulator testing", "Git", "GitHub Actions", "CI/CD", "EAS Build / Submit", "Apple App Store", "Google Play", "Firebase Hosting", "Heroku"] },
  { title: "Enterprise", skills: ["NetSuite SuiteCommerce Advanced", "SuiteScript", "Klaviyo"] },
  { title: "AI-Assisted Development", skills: ["OpenAI Codex", "Claude Code", "Agentic coding workflows"] },
];

export default function About() {
  return (
    <section className="recruiter-section" id="about" aria-labelledby="skills-title">
      <Container>
        <p className="recruiter-eyebrow">Technical toolkit</p>
        <h2 id="skills-title">Skills</h2>
        <div className="recruiter-skills-grid">
          {skillGroups.map(({ title, skills, level }) => (
            <div
              className={`recruiter-skill-group${level === "core" ? " recruiter-skill-group--core" : ""}`}
              key={title}
            ><h3>{title}</h3>
              <ul>{skills.map(skill => <li key={skill}>{skill}</li>)}</ul>
            </div>
          ))}
        </div>
        <div className="recruiter-education">
          <img src={Photo} alt="Dmitry Kordik" width="100" height="100" loading="lazy" />
          <div><h3>Education &amp; certification</h3>
            <p>Seneca College · Diploma, Computer Programming<br />September 2018 – December 2020</p>
            <p>Klaviyo Developer Certificate</p>
          </div>
        </div>
      </Container>
    </section>
  );
}
